export class FeatureToggleValue {
    static available:string = "Available";
    static disabled:string = "Disabled";
    static hidden:string = "Hidden";
}